import { Ability } from "@/interfaces/ability";
import { set } from "lodash";
import { defineStore } from "pinia";
import { computed, ref } from "vue";

interface RoleGroup {
  model: string;
  abilities: Ability[];
}

export const useRoleAbilitiesStore = defineStore("roleAbilities", () => {
  const roleAbilities = ref<Ability[]>([]);
  const roleGroupAbilities = ref<RoleGroup>();
  const roleId = ref<number>();

  // Snapshot de los permisos marcados tal como llegaron del server (o al último
  // guardado). Permite saber si el editor de roles tiene cambios sin guardar
  // antes de cambiar de rol (los toggles mutan roleAbilities directamente).
  const savedSnapshot = ref<string>("");

  const serializeChecked = () =>
    roleAbilities.value
      .filter((ability) => ability.checked)
      .map((ability) => ability.id)
      .sort((a, b) => a - b)
      .join(",");

  const hasUnsavedChanges = computed(
    () => serializeChecked() !== savedSnapshot.value,
  );

  return {
    roleAbilities,
    roleGroupAbilities,
    roleId,
    hasUnsavedChanges,

    setRoleGroupAbilities(value: RoleGroup) {
      roleGroupAbilities.value = value;
    },
    setRoleAbilities(value: Ability[]) {
      roleAbilities.value = value;
      savedSnapshot.value = serializeChecked();
    },
    snapshotRoleAbilities() {
      savedSnapshot.value = serializeChecked();
    },
    setRoleId(value: number) {
      roleId.value = value;
    },
  };
});
